/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC, useEffect, useMemo, useState} from 'react'
import {Column} from 'react-table'
import {KTCard} from '../../../../../../../../_metronic/helpers'
import {
  KTable,
  KTableHeader,
  KTableLoading,
  KTableSelectionCellNonMultiple,
} from '../../../../../../components/UI'
import {KTableProvider, useKTable} from '../../../../../../contexts/KTableProvider'
import {Button, ButtonWrapper} from '../../../../../../components/UI/Button'
import {SelectOption} from '../../../../../../models/utility.model'
import {useCentralServices} from '../../../../hooks/useCentralServices'
import {FormProvider, useForm} from 'react-hook-form'
import {cancellationsChangesFilterSchema} from '../../../../../../util/validationHoteleria'
import {yupResolver} from '@hookform/resolvers/yup'
import {InputTextWrapper, SelectWrapper} from '../../../../../../components/UI/Form/Input'
import {ModalCancellationsChanges} from '../Modals/ModalCancellationsChanges'
import {CancelChangeColumn, CancelChangeTableDto} from '../../../../models/cancel-change'
import {getListBookings} from '../../../../services/cancel-change.service'
import moment from 'moment'
import {ShowSnackBar} from '../../../../../../util/functions'
import {useKhipu} from '../../../../../../hooks/useKhipu'
import {paginationGuestsService} from '../../../guests/services'
import {formatDateDDMMYYYY} from '../../../../../../util/dates'

const TableCancellations: FC = () => {
  const {
    data,
    setData,
    setPagination,
    loading,
    setLoading,
    pagination,
    clearSelected,
    selectedOn,
    clearTable,
    updateTable,
    setClearTable,
    setUpdateTable,
  } = useKTable()
  const methods = useForm<CancelChangeTableDto>({
    resolver: yupResolver(cancellationsChangesFilterSchema),
    defaultValues: {
      CompaniaId: '',
      ClienteId: '',
      CampamentoId: '',
      SiteId: '',
      // HuespedId: '',
      // NroReserva: '',
    },
  })
  const {setValue, handleSubmit, setError, reset, watch} = methods
  const {getCompanies, getClients, getSites, getCamps, getMasterTable} = useCentralServices()
  const {clearSearchValues, searchValues} = useKhipu()
  const [compani, setCompany] = useState<SelectOption[]>([])
  const [client, setClient] = useState<SelectOption[]>([])
  const [site, setSite] = useState<SelectOption[]>([])
  const [camp, setCamp] = useState<SelectOption[]>([])
  const [roomType, setRoomType] = useState<SelectOption[]>([])
  const [formValue, setFormValue] = useState<any>(null)
  const [formValueLoading, setFormValueLoading] = useState<any>(false)
  const [showModal, setShowModal] = useState<boolean>(false)
  const [bookingItem, setBookingItem] = useState<CancelChangeColumn>()

  useEffect(() => {
    getCompaniesFn()
    getRoomsTypeFn()
    return () => {
      clearSearchValues()
    }
  }, [])

  const getCompaniesFn = async () => {
    const data = await getCompanies({isCombo: true}, 1)
    if (data.length === 1) {
      setValue('CompaniaId', data[0].value as string)
      setError('CompaniaId', {})
      await getClientsFn(data[0].value as string)
    }
    const allData = [...data]
    setCompany(allData)
  }

  const getClientsFn = async (companyId: string) => {
    const data = await getClients({isCombo: true, companiaId: companyId}, 1)
    if (data.length === 1) {
      setValue('ClienteId', data[0].value as string)
      setError('ClienteId', {})

      await getSitesFn(data[0].value as string)
    }
    const allData = [...data]
    setClient(allData)
  }

  const getSitesFn = async (clientId: string) => {
    const data = await getSites({isCombo: true, clienteId: clientId}, 1)
    if (data.length === 1) {
      setValue('SiteId', data[0].value as string)
      setError('SiteId', {})
      await getCampsFn(data[0].value as string)
    }
    const allData = [...data]
    setSite(allData)
  }

  const getCampsFn = async (siteId: string) => {
    const data = await getCamps({isCombo: true, siteId: siteId}, 1)
    if (data.length === 1) {
      setValue('CampamentoId', data[0].value as string)
      setError('CampamentoId', {})
    }
    const allData = [...data]
    setCamp(allData)
  }

  const getRoomsTypeFn = async () => {
    const data = await getMasterTable('TipoHabitacion', true)
    setRoomType(data)
  }

  const getBedBookings = async (dataFilter: any = null) => {
    try {
      if (formValue) {
        setLoading(true)
        let obj = {
          ...searchValues,
          NroReserva: searchValues.NroReservaTable
            ? searchValues.NroReservaTable
            : watch('NroReserva'),
          FechaInicioProgramada: searchValues?.FechaInicioProgramada
            ? formatDateDDMMYYYY(searchValues.FechaInicioProgramada)
            : '',
          FechaFinProgramada: searchValues?.FechaFinProgramada
            ? formatDateDDMMYYYY(searchValues.FechaFinProgramada)
            : '',
          FechaCheckin: searchValues?.FechaCheckin
            ? formatDateDDMMYYYY(searchValues.FechaCheckin)
            : '',
          FechaCheckout: searchValues?.FechaCheckout
            ? formatDateDDMMYYYY(searchValues.FechaCheckout)
            : '',
          HuespedNroDoc: searchValues.HuespedNroDocTable
            ? searchValues.HuespedNroDocTable
            : watch('HuespedNroDoc'),
        }
        const {data: response} = await getListBookings({
          CompaniaId: watch('CompaniaId'),
          CampamentoId: watch('CampamentoId'),
          ClienteId: watch('ClienteId'),
          SiteId: watch('SiteId'),
          NroReserva: watch('NroReserva'),
          HuespedNroDoc: watch('HuespedNroDoc'),
          pageNumber: pagination.currentPage,
          size: pagination.perPage,
          ...dataFilter,
          ...obj,
        })
        if (!response.error) {
          setData(response.data)
          setPagination({
            ...pagination,
            currentPage: dataFilter ? dataFilter.pageNumber : pagination.currentPage,
            totalResults: response.total,
          })
        } else {
          ShowSnackBar(response.message, 'error')
        }
        clearSelected()
        setLoading(false)
      }
    } catch (error) {
      setLoading(false)
    }
  }

  const loadOptionsFilter = async (inputValue: string) => {
    try {
      if (inputValue.length < 3) {
        return []
      }
      const {data: response} = await paginationGuestsService({
        pageNumber: 1,
        size: 500,
        BuscaTexto: inputValue,
      })
      if (!response.error) {
        const mappedGuests = response.data?.map((guest) => ({
          value: guest.Id,
          label: `${guest.Nombres} ${guest.ApellidoPaterno} ${guest.ApellidoMaterno}`,
        }))
        return mappedGuests
      } else {
        return []
      }
    } catch (error) {
      console.error('Error fetching options:', error)
      return []
    }
  }

  const columns: Column<CancelChangeColumn>[] = useMemo(
    () => [
      {
        Header: (props) => <KTableHeader tableProps={props} />,
        id: 'selection',
        Cell: ({...props}) => (
          <KTableSelectionCellNonMultiple id={props.data[props.row.index].ReservaCamaId} />
        ),
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Nro de Reserva'
            name='NroReservaTable'
            searcheable
          />
        ),
        accessor: 'NroReserva',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Nomenclatura de Módulo'
            name='NomenclaturaModulo'
            searcheable
          />
        ),
        accessor: 'Modulo',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Tipo de Habitación'
            name='TipoHabitacionId'
            selecteable
            data={roomType}
          />
        ),
        accessor: 'TipoHabitacion',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Nomenclatura de Habitación'
            name='NomenclaturaHabitacion'
            searcheable
          />
        ),
        accessor: 'Habitacion',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Nomenclatura de Cama'
            name='NomenclaturaCama'
            searcheable
          />
        ),
        accessor: 'Cama',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Fecha inicio programada'
            name='FechaInicioProgramada'
            dateable
          />
        ),
        accessor: 'FechaInicio',
        Cell: ({...props}) => (
          <div>
            {props.row.original.FechaInicio
              ? moment(props.row.original.FechaInicio, 'DD/MM/YYYY').local().format('DD/MM/YYYY')
              : ''}
          </div>
        ),
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Fecha fin programada'
            name='FechaFinProgramada'
            dateable
          />
        ),
        accessor: 'FechaFin',
        Cell: ({...props}) => (
          <div>
            {props.row.original.FechaFin
              ? moment(props.row.original.FechaFin, 'DD/MM/YYYY').local().format('DD/MM/YYYY')
              : ''}
          </div>
        ),
      },
      {
        Header: (props) => (
          <KTableHeader tableProps={props} title='Fecha Checkin' name='FechaCheckin' dateable />
        ),
        accessor: 'FechaCheckIn',
        Cell: ({...props}) => (
          <div>
            {props.row.original.FechaCheckIn
              ? moment(props.row.original.FechaCheckIn, 'DD/MM/YYYY').local().format('DD/MM/YYYY')
              : ''}
          </div>
        ),
      },
      {
        Header: (props) => (
          <KTableHeader tableProps={props} title='Fecha Checkout' name='FechaCheckout' dateable />
        ),
        accessor: 'FechaCheckOut',
        Cell: ({...props}) => (
          <div>
            {props.row.original.FechaCheckOut
              ? moment(props.row.original.FechaCheckOut, 'DD/MM/YYYY').local().format('DD/MM/YYYY')
              : ''}
          </div>
        ),
      },
      {
        Header: (props) => (
          <KTableHeader tableProps={props} title='Nro Doc' name='HuespedNroDocTable' searcheable />
        ),
        accessor: 'HuespedNroDoc',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Huesped'
            name='HuespedId'
            size='250px'
            selectLabel='HuespedLabel'
            selecteableAsync
            loadOptions={loadOptionsFilter}
            placeholder='Busca un Huésped...'
          />
        ),
        accessor: 'Huesped',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='RUC Contratista'
            name='RucContratista'
            searcheable
          />
        ),
        accessor: 'RucContratista',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Razon Social Contratista'
            name='RazSocContratista'
            searcheable
          />
        ),
        accessor: 'RazonSocialContratista',
      },
    ],
    [roomType],
  )

  useEffect(() => {
    getBedBookings()
    clearSelected()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pagination.currentPage])

  useEffect(() => {
    if (clearTable) {
      if (pagination.currentPage === 1) {
        getBedBookings()
      } else {
        setPagination({
          ...pagination,
          currentPage: 1,
          perPage: 10,
          totalResults: 0,
        })
      }

      // setData([])
      setClearTable(false)
    }
  }, [clearTable])

  useEffect(() => {
    if (updateTable) {
      if (pagination.currentPage === 1) {
        getBedBookings()
      } else {
        setPagination({
          ...pagination,
          currentPage: 1,
          perPage: 10,
          totalResults: 0,
        })
      }
      setUpdateTable(false)
    }
  }, [updateTable])

  const handleFilterClient = (e: any) => {
    let value = e.value
    setValue('ClienteId', '')
    setValue('SiteId', '')
    setValue('CampamentoId', '')
    setValue('HuespedId', '')
    setSite([])
    setCamp([])
    getClientsFn(value)
    setValue('CompaniaId', value)
    setError('CompaniaId', {})
  }

  const handleFilterSite = (e: any) => {
    let value = e.value
    setValue('SiteId', '')
    setValue('CampamentoId', '')
    setValue('HuespedId', '')
    getSitesFn(value)
    setValue('ClienteId', value)
    setError('ClienteId', {})
    setCamp([])
  }

  const handleFilterCamp = (e: any) => {
    let value = e.value
    setValue('CampamentoId', '')
    getCampsFn(value)
    setValue('SiteId', value)
    setError('SiteId', {})
    setCamp([])
  }

  const handleClear = () => {
    reset()
    setFormValue(null)
    setClient([])
    setSite([])
    setCamp([])
    setPagination({
      ...pagination,
      currentPage: 1,
      perPage: 10,
      totalResults: 0,
    })
    setData([])
  }

  const onSubmit = (dataForm: any) => {
    setPagination({
      ...pagination,
      currentPage: 1,
      perPage: 10,
      totalResults: 0,
    })
    setFormValue(dataForm)
    setFormValueLoading(true)
  }

  const handleCancellationsChanges = () => {
    const [selectedItem] = selectedOn
    const selectBooking = data.find((item) => item.ReservaCamaId === selectedItem)
    setBookingItem(selectBooking)
    setShowModal(true)
  }

  useEffect(() => {
    if (formValueLoading) {
      setFormValueLoading(false)
      clearSearchValues()
      setClearTable(true)
      // getBedBookings()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formValueLoading])

  useEffect(() => {
    setLoading(loading)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading])

  return (
    <>
      <KTCard shadow className='m-5'>
        <>
          <FormProvider {...methods}>
            <form className='m-2'>
              <div className='row'>
                <div className='col-sm-12 col-lg-3'>
                  <SelectWrapper
                    labelText='Compañía'
                    name='CompaniaId'
                    data={compani}
                    onChangeValue={handleFilterClient}
                    required
                  />
                </div>
                <div className='col-sm-12 col-lg-3'>
                  <SelectWrapper
                    labelText='Cliente'
                    name='ClienteId'
                    data={client}
                    onChangeValue={handleFilterSite}
                    required
                  />
                </div>
                <div className='col-sm-12 col-lg-3'>
                  <SelectWrapper
                    labelText='Site'
                    name='SiteId'
                    data={site}
                    onChangeValue={handleFilterCamp}
                    required
                  />
                </div>
                <div className='col-sm-12 col-lg-3'>
                  <SelectWrapper labelText='Campamento' name='CampamentoId' data={camp} required />
                </div>
                <div className='col-sm-12 col-lg-3'>
                  <InputTextWrapper
                    labelText='Huésped'
                    name='HuespedNroDoc'
                    textPlaceholder='Buscar por nro documento'
                    type='alphaNumeric'
                  />
                </div>
                <div className='col-sm-12 col-lg-3'>
                  <InputTextWrapper
                    labelText='Nro de Reserva'
                    name='NroReserva'
                    textPlaceholder='Escribe el nro de reserva'
                    type='numeric'
                  />
                </div>
              </div>
            </form>
            <ButtonWrapper className={'sdx-white-bg'}>
              <Button label='Buscar' onClick={handleSubmit(onSubmit)} />
              <Button label='Limpiar' onClick={handleClear} />
            </ButtonWrapper>
          </FormProvider>
        </>
        {/* <pre>{JSON.stringify(watch(), null, 2)}</pre> */}
        <div className='d-flex justify-content-end p-2 me-5'>
          <button
            className='btn btn-success me-3'
            disabled={selectedOn.length < 1}
            onClick={handleCancellationsChanges}
            type='button'
          >
            Realizar Anulación y Cambios
          </button>
        </div>
        <KTable data={data} columns={columns as any} />
        {loading ? <KTableLoading title='Cargando...' /> : null}
        {showModal ? (
          <ModalCancellationsChanges
            show={showModal}
            setShow={setShowModal}
            booking={bookingItem}
            // checkIn={checkIn}
            getData={getBedBookings}
          />
        ) : (
          <></>
        )}
      </KTCard>
    </>
  )
}

const TableCancellationsChangesWrapper = () => {
  return (
    <KTableProvider>
      <TableCancellations />
    </KTableProvider>
  )
}

export {TableCancellationsChangesWrapper}
